
import { Options, Vue } from "vue-class-component";
import HelloWorld from "./components/HelloWorld.vue";
//import ExpCell from "./components/ExpressionCell.vue";
import Grid from "./components/Grid.vue";
import IntegradleTitle from "./components/IntegradleTitle.vue";
import Keyboard from "./components/Keyboard.vue";
import Visualizer from "./components/Visualizer.vue";

@Options({
    components: {
        HelloWorld,
        Grid,
        IntegradleTitle,
        Keyboard,
        Visualizer,
    },
})
export default class App extends Vue {
    isKBOpen = true;

    get position(): string {
        return (
            this.$store.state.currentRow + ":" + this.$store.state.currentColumn
        );
    }

    created() {
        let theme = window.localStorage.getItem("theme");
        if (theme == undefined) {
            theme = "light";
        }
        this.$store.commit("SET_THEME", theme);
        this.newPuzzle();
    }

    newPuzzle(isHardmode = false) {
        this.$store.commit("NEW_PUZZLE", isHardmode);
    }

    get previewExpression(): string {
        return this.$store.state.previewExpression;
    }

    get isFinished() {
        return this.$store.state.isFinished;
    }

    pushKey(event: KeyboardEvent) {
        if (event.key == "Backspace") {
            // clear if ctrl key is pressed, otherwise backspace normally
            this.popCharacter(event.ctrlKey);
        } else if (event.key == "Enter") {
            this.submit();
        } else if (event.key == "ArrowLeft") {
            this.$store.commit("MOVE_LEFT");
        } else if (event.key == "ArrowRight") {
            this.$store.commit("MOVE_RIGHT");
        } else if (event.key == "c") {
            // typing lowercase c will yield uppercase C instead
            this.pushCharacter("C");
        } else if (event.key.length == 1) {
            this.pushCharacter(event.key);
        } else {
            console.log(event.key);
        }
    }

    pushCharacter(char: string) {
        this.$store.dispatch("PUSH_CHARACTER", char);
    }

    popCharacter(clear = false) {
        this.$store.dispatch("POP_CHARACTER", clear);
    }

    submit() {
        this.$store.dispatch("SUBMIT");
    }

    get theme() {
        return this.$store.state.theme;
    }

    toggleDarkMode() {
        const newTheme = this.theme == "light" ? "dark" : "light";
        this.$store.commit("SET_THEME", newTheme);
    }
}
